import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faNewspaper } from '@fortawesome/pro-regular-svg-icons/faNewspaper';
import type { NewsWidgetModel } from 'src/models/NewsWidgetModel';
import { NewsWidgetModelImpl } from 'src/models/NewsWidgetModel/impl';
import type { NewsWidgetState } from 'src/models/TimeListWidgetState/schemas';

export const newsWidgetDefinition: SelfOwnedWidgetDefinition<NewsWidgetState, NewsWidgetModel> = {
    type: 'news',
    nameKey: 'widgets::news::name',
    roles: ['widgets::news'],
    icon: faNewspaper,
    category: 'widgets::categories::research',
    defaultDimensions: { h: 0.8, w: 0.33, x: 0.33, y: 0.1 },
    widgetClass: NewsWidgetModelImpl,
};
